"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('functionExpression'),
    title: 'Function expression',
    anyOf: [
        { $ref: jsonschema_1.$id('functionDeclarationExpression') },
        { $ref: jsonschema_1.$id('externalFunctionExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=function.schema.js.map